import UniversalNotifications from './UniversalNotifications'

export default UniversalNotifications
